// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tF7B","delete":"styles_delete__3SFid","update":"styles_update__3Dtvp","add":"styles_add__276hn"};